module.exports = __webpack_public_path__ + "img/banner-bg-small.8c60bf3c.webp";